var helpcardMessage = angular.module('helpCardMessage', []);
helpcardMessage.directive('helpCardMessage', function() {
    return {
        restrict: 'E',
        scope: { active: '=', helpMsg: '=' },
        templateUrl: 'ism-angular-lib/directives/helpCardMessage/helpCardMessage.html?v=' + versionNo,
        controller: function($scope, $sce)
        {
            $scope.sce = $sce;
            $scope.versionNo = versionNo;
        }
    };
});